import FundPerformanceChart from "./website/fund-performance-chart";
import FundNavChart from "./website/fund-nav-chart";

class WebsitePerformanceChart {
    constructor(fundCode) {
        this.fundPerformanceChart = new FundPerformanceChart("container-performance", fundCode);
        this.bindEvents();
    }

    bindEvents() {
        $("#history-performance").on("click", () => {
            this.fundNavChart.chart.reflow();
        });
    }

    render() {
        this.fundPerformanceChart.render();
    }
}

class WebsiteNavChart {
    constructor(fundCode) {
        this.fundNavChart = new FundNavChart("container-history", fundCode);
        this.bindEvents();
    }

    bindEvents() {
        $("#history-performance").on("click", () => {
            this.fundNavChart.chart.reflow();
        });
    }

    render() {
        this.fundNavChart.render();
    }
}

$(function () {
    if (window.fundCode && $("#container-performance-c").length > 0) {
        const websitePerformanceChart = new WebsitePerformanceChart(window.fundCode);
        websitePerformanceChart.render();
    }
    if (window.fundCode && $("#container-history-c").length > 0) {
        const websiteNavChart = new WebsiteNavChart(window.fundCode);
        websiteNavChart.render();
    }
});
